(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["file-download-list"] && !Shopify.designMode) return;
  try {
    class FileDownloadList extends HTMLElement {
    connectedCallback() {
      this.querySelector('[data-next-url]')?.addEventListener('click', this.loadMore.bind(this))
    }

    async loadMore(event) {
      const button = event.currentTarget

      if (button.getAttribute('aria-busy') === 'true') return

      const url = new URL(button.dataset.nextUrl, window.location.origin)
      url.searchParams.set('section_id', this.dataset.sectionId)
      button.setAttribute('aria-busy', 'true')

      try {
        const response = await fetch(url)
        const html = new DOMParser().parseFromString(await response.text(), 'text/html')
        const next = html.querySelector(
          `file-download-list[data-block-id="${this.dataset.blockId}"]`
        )
        const nextUrl = next.querySelector('[data-next-url]')?.dataset.nextUrl

        this.querySelector('.file-download-list').append(
          ...next.querySelector('.file-download-list').children
        )

        if (nextUrl) {
          button.dataset.nextUrl = nextUrl
        } else {
          button.remove()
        }
      } finally {
        button.removeAttribute('aria-busy')
      }
    }
  }

  if (!window.customElements.get('file-download-list')) {
    window.customElements.define('file-download-list', FileDownloadList)
  }
  } catch(e) { console.error(e); }
})();

})();
